import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {PaymentFailedIcon} from "../../../../../SVGElements";
import {Messages} from "../../../../../Messages";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {PaymentFailedPanelStyle} from "../../payment-method/PaymentFailedPanel";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {Controller} from "../../../../Controller";


@registerStyle(PaymentFailedPanelStyle)
export class EditSubscriptionCancelSuccessPanel extends BasePanelPage {
    render() {
        const {styleSheet} = this;

        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <PaymentFailedIcon className={styleSheet.icon} color={styleSheet.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
            <div className={styleSheet.title}>{Messages.subscriptionCanceled}</div>,
            <MerchantButton className={styleSheet.button} onClick={() => Controller.subscriptionPlan.onCancel()}>
                {Messages.ok}
            </MerchantButton>
        ];
    }
}
